import { descriptorsFactory } from '../../utils/filters';

export const NOT_FIRST_VALUE = 'NotFirst';
export const NOT_LAST_VALUE = 'NotLast';
export const ONLY_LAST_VALUE = 'OnlyLast';
export const NOT_FIRST_NOT_LAST_VALUE = 'NotFirstNotLast';

export const floorTypeDescriptors = descriptorsFactory({
  name: 'FloorType',
  clear: ['is_first_floor', 'is_last_floor'],
})(
  {
    form: [{ key: 'is_first_floor', value: false, type: 'term' }],
    label: 'Не первый',
    state: NOT_FIRST_VALUE,
  },
  {
    form: [{ key: 'is_last_floor', value: false, type: 'term' }],
    label: 'Не последний',
    state: NOT_LAST_VALUE,
  },
  {
    form: [
      { key: 'is_first_floor', value: false, type: 'term' },
      { key: 'is_last_floor', value: false, type: 'term' },
    ],
    label: 'Не первый и не последний',
    state: NOT_FIRST_NOT_LAST_VALUE,
  },
  {
    form: [{ key: 'is_last_floor', value: true, type: 'term' }],
    label: 'Только последний',
    state: ONLY_LAST_VALUE,
  },
  {
    form: [],
    label: 'Без фильтра',
    state: '',
  },
);
